function FilterSendRequest(path, message, filter) {
    this.path = path;
    this.message = message;
    this.filter = filter;
}

module.exports = FilterSendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/filter-send-request.js
// module id = 335
// module chunks = 1